module.exports = __webpack_public_path__ + "img/yxjp.c4458cb8.png";